import React from 'react';
import { ConfirmContext } from './confirmProvider';

let useConfirm = () => {
  let { confirm } = React.useContext(ConfirmContext);
  return confirm;
};
export default useConfirm;
